export default {
  meta: {
    title: '门店地图',
    url: '/storemap/universal', // 埋点字段，上报归属的模块
    urlName: '门店地图' // 埋点字段，上报归属的模块
  }
};
